import { render, staticRenderFns } from "./ExercisesEmpty.vue?vue&type=template&id=2c042f68"
import script from "./ExercisesEmpty.vue?vue&type=script&lang=js"
export * from "./ExercisesEmpty.vue?vue&type=script&lang=js"
import style0 from "./ExercisesEmpty.vue?vue&type=style&index=0&id=2c042f68&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports